import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ClinicIntroPage from './pages/ClinicIntroPage';
import NaturalTeethPage from './pages/NaturalTeethPage';
import ImplantPage from './pages/ImplantPage';

import FrontTeethPage from './pages/FrontTeethPage';
import OrthodonticsPage from './pages/OrthodonticsPage';
import ChildrenPage from './pages/ChildrenPage';
import './App.css';
import { SITE_URL } from './utils/clinicInfo';

// App 내부 컴포넌트로 라우팅 처리
const AppContent = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // 라우트 변경 시 적절한 처리
  useEffect(() => {
    if (isHomePage) {
      // 홈페이지인 경우: fullPage.js가 활성화되도록 준비
      // HomePage 컴포넌트에서 fullpage-enabled 클래스와 fullPage.js를 초기화함
    } else {
      // 일반 페이지인 경우: fullPage.js 정리 및 스크롤 복원
      
      // fullPage.js 제거
      if (window.$ && window.$.fn && window.$.fn.fullpage && window.$.fn.fullpage.destroy) {
        window.$.fn.fullpage.destroy('all');
      }
      
      // body에서 fullpage-enabled 클래스 제거
      document.body.classList.remove('fullpage-enabled');
      
      // fullPage.js 관련 클래스들 모두 제거
      document.body.classList.remove('fp-enabled', 'fp-responsive', 'fp-viewing-0', 'fp-viewing-section1');
      document.documentElement.classList.remove('fp-enabled', 'fp-responsive');
      
      // 스크롤 복원을 위한 스타일 정리
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.body.style.transform = '';
      document.body.style.touchAction = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
      document.documentElement.style.transform = '';
      document.documentElement.style.touchAction = '';
      
      // 페이지 상단으로 스크롤
      window.scrollTo(0, 0);
    }
  }, [location.pathname, isHomePage]);

  // 페이지마다 canonical 주소를 현재 페이지로 설정 (모든 페이지가 홈을 대표 페이지로 가리키지 않도록)
  useEffect(() => {
    const tab = new URLSearchParams(location.search).get('tab');
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${SITE_URL}${location.pathname}${tab ? `?tab=${encodeURIComponent(tab)}` : ''}`;
  }, [location.pathname, location.search]);

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/clinic-intro" element={<ClinicIntroPage />} />
        <Route path="/natural-teeth" element={<NaturalTeethPage />} />
        <Route path="/implant" element={<ImplantPage />} />

        <Route path="/front-teeth" element={<FrontTeethPage />} />
        <Route path="/orthodontics" element={<OrthodonticsPage />} />
        <Route path="/children" element={<ChildrenPage />} />
      </Routes>
      {/* 홈페이지가 아닐 때만 푸터 표시 */}
      {!isHomePage && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
    <div className="App">
        <AppContent />
    </div>
    </Router>
  );
}



export default App;
